<template>
  <div id="ranking_all" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
    <van-row>
      <van-col span="24" :class="isFull === 1 ? 'ranking_all_reward_bg_'+ranking_active+' ranking_all_bg top_information' : 'ranking_all_reward_bg_'+ranking_active+' ranking_all_bg' ">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              fixed
              class="ranking_all_bg_bar"
              @click-left="onClickLeft"
          >
            <template #title>
              <van-tabs v-model="ranking_active" @click="onClickRankingActive" line-width="20px" title-active-color="#ffffff" title-inactive-color="#9B9CBF">
                <van-tab :title="$t('column.room_rank')" name="room"/>
                <van-tab :title="$t('column.gift_rank')" name="gift"/>
                <van-tab :title="$t('column.charm_rank')" name="charm"/>
                <van-tab :title="$t('column.game_rank')" name="game"/>
              </van-tabs>
            </template>
          </van-nav-bar>
        </van-col>
        <van-col span="22" offset="1" class="ranking_all_top_day">
          <van-tabs type="card" v-model="day_active" @click="onClickRankingDay">
            <van-tab :title="$t('column.day_list')" name="day"></van-tab>
            <van-tab :title="$t('column.week_list')" name="week"></van-tab>
            <van-tab :title="$t('column.Monthly_list')" name="month"></van-tab>
          </van-tabs>
        </van-col>

        <van-col span="22" offset="1">
          <van-col span="8">
            <van-col span="22" offset="1" class="ranking_all_reward_2" @click="JumpUserinfo(list.length > 1 ? list[1].user_id : 0)">
               <picture>
              <source srcset="../assets/img/rank/rank2.webp" type="image/webp">
              <img src="../assets/img/rank/rank2.png" class="ranking_all_reward_avatar_img2"/>
            </picture>
              <van-image
                  width="14vw"
                  height="14vw"
                  round
                  class="ranking_all_2_avatar"
                  fit="cover"
                  :src="list[1].head_image"
                  v-if="list.length > 1"
              />
              <van-col span="22" offset="1" class="ranking_all_list_name" v-if="list.length > 1">{{ list[1].nick_name }} </van-col>
              <van-col span="22" offset="1" class="ranking_all_list_coin" v-if="list.length > 1">  <img :src="ranking_active === 'charm' ? coin9 : coin11 "/> {{ list[1].coin }} </van-col>
            </van-col>
          </van-col>
          <van-col span="8" class="ranking_all_reward_1"  @click="JumpUserinfo(list.length > 0 ? list[0].user_id : 0)">
            <picture>
              <source srcset="../assets/img/rank/rank1.webp" type="image/webp">
              <img src="../assets/img/rank/rank1.png" class="ranking_all_reward_avatar_img"/>
            </picture>
            <van-image
                width="14vw"
                height="14vw"
                round
                class="ranking_all_reward_1_avatar"
                fit="cover"
                :src="list[0].head_image"
                v-if="list.length > 0"
            />
            <van-col span="22" offset="1" class="ranking_all_list_name" v-if="list.length > 0">{{ list[0].nick_name }} </van-col>
            <van-col span="22" offset="1" class="ranking_all_list_coin" v-if="list.length > 0"><img :src="ranking_active === 'charm' ? coin9 : coin11 "/> {{ list[0].coin }}</van-col>
          </van-col>
          <van-col span="8">
            <van-col span="22" offset="1" class="ranking_all_reward_3" @click="JumpUserinfo(list.length > 2 ? list[2].user_id : 0)">
              <picture>
              <source srcset="../assets/img/rank/rank3.webp" type="image/webp">
              <img src="../assets/img/rank/rank3.png" class="ranking_all_reward_avatar_img3"/>
            </picture>
              <van-image
                  width="14vw"
                  height="14vw"
                  round
                  class="ranking_all_2_avatar"
                  fit="cover"
                  :src="list[2].head_image"
                  v-if="list.length > 2"
              />
              <van-col span="22" offset="1" class="ranking_all_list_name" v-if="list.length > 2">{{ list[2].nick_name }}  </van-col>
              <van-col span="22" offset="1" class="ranking_all_list_coin" v-if="list.length > 2"><img :src="ranking_active === 'charm' ? coin9 : coin11 "/> {{ list[2].coin }} </van-col>
            </van-col>
          </van-col>
        </van-col>
        <van-col span="24" class="ranking_all_reward_list">
          <img src="../assets/img/ranking_all_reward_kuang_l.png" class="ranking_all_reward_k_l"/>
          <img src="../assets/img/ranking_all_reward_kuang_r.png" class="ranking_all_reward_k_r"/>
          <img src="../assets/img/ranking_all_reward_kuang_title.png" class="ranking_all_reward_k_c"/>
          <div class="ranking_all_reward_k_text">List rewards</div>
          <van-col span="24" class="ranking_all_reward_list_text">*Rewarded according to the ranking of the local list</van-col>
          <van-col span="24" class="ranking_all_reward_list_type" v-for="(item,i) in reward_list" :key="i">
            <van-col span="24" class="ranking_all_reward_list_top">Top{{ item.rank_i }}</van-col>
            <van-col span="24" class="ranking_all_reward_list_centent">
              <van-col span="8" class="ranking_all_reward_list_centent_item" v-for="(t,j) in item.list" :key="j">
                <van-col span="22" offset="1" class="ranking_all_reward_list_centent_item_bg">
                  <div class="ranking_all_reward_list_centent_item_top" v-if="t.type !=='coin'">3D</div>
                  <van-col span="22" offset="1" class="ranking_all_reward_list_centent_item_img">
                    <div v-if="t.type==='frame'">
                      <picture v-if="isWebP(t.img)">
                        <source :srcset="t.img" type="image/webp" >
                        <img :src="t.img" class="ranking_all_reward_list_item_avata_frame" />
                      </picture>
                      <div :id='"popular_svga"+t.rank_i' class="ranking_all_reward_list_item_avata_frame" v-else></div>
                    </div>

                    <img :src="t.img" v-else-if="t.img"/>
                    <img :src="ranking_active === 'charm' ? coin9 : coin11 " v-else-if="t.type==='coin'"/>
                    <img src="../assets/img/luck_img.png" v-else-if="t.type==='luck'"/>
                  </van-col>
                </van-col>
                <van-col span="22" offset="1" class="ranking_all_reward_list_centent_item_title"> {{ t.name }}<span v-if="t.id"> x {{ t.day }} {{ $t('other.day')}}</span></van-col>
              </van-col>

            </van-col>
          </van-col>

        </van-col>
      </van-col>
      <van-overlay :show="overlayShow" z-index="3">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import SVGA from "svgaplayerweb";
import {judgeIosAndroid} from "../assets/js/models";

export default {
  data() {
    return {
      day_active: 'day',
      ranking_active: 'room',
      list: [],
      coin9: require('../assets/img/coin9.png'),
      coin11: require('../assets/img/coin11.png'),
      reward_list:[],
      overlayShow: false,
      finished: false,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      loading_request: false, // 接口是否在请求中
      touchStartX: 0, // 触摸开始X坐标
      touchStartY: 0, // 触摸开始Y坐标
      touchEndX: 0, // 触摸结束X坐标
      touchEndY: 0, // 触摸结束Y坐标
      day_tabs: ['day', 'week', 'month'] // 时间tab顺序
    }
  },
  created: function () {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.convert()
    document.title = this.$t('column.ranking')
  },
  methods: {
    isWebP(url) {
      if (!url) return false
      // 去除查询参数和哈希
      const cleanUrl = url.split('?')[0].split('#')[0]
      // 获取扩展名
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'webp'
    },
    judgeIosAndroid,
    onClickRankingActive(name, title) {
      // 如果接口正在请求中，阻止切换
      if (this.loading_request) {
        this.$toast(this.$t('other.loading') || '加载中...')
        return
      }
      this.ranking_active = name
      this.convert()
    },
    onClickRankingDay(name, title) {
      // 如果接口正在请求中，阻止切换
      if (this.loading_request) {
        this.$toast(this.$t('other.loading') || '加载中...')
        return
      }
      this.day_active = name
      this.convert()
    },
    // 触摸开始
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    },
    // 触摸移动
    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX
      this.touchEndY = e.touches[0].clientY
    },
    // 触摸结束
    handleTouchEnd() {
      // 如果接口正在请求中，禁止滑动切换
      if (this.loading_request) {
        return
      }
      
      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY
      
      // 判断是否为水平滑动（水平移动距离大于垂直移动距离，且大于50px）
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        const currentIndex = this.day_tabs.indexOf(this.day_active)
        
        if (deltaX > 0) {
          // 向右滑动，切换到上一个tab
          if (currentIndex > 0) {
            this.day_active = this.day_tabs[currentIndex - 1]
            this.convert()
          }
        } else {
          // 向左滑动，切换到下一个tab
          if (currentIndex < this.day_tabs.length - 1) {
            this.day_active = this.day_tabs[currentIndex + 1]
            this.convert()
          }
        }
      }
    },
    onClickLeft() {
      this.$router.go(-1); // 返回上一页
    },
    JumpUserinfo(id) {
      console.log(id)
      if(id){
        // 拦截跳转用户主页面
        window.location.href="live://live?action=JumpUser&id=" + id
      }
    },
    SVGA() {
      this.$nextTick(()=>{
        for (let i= 0;i<this.reward_list.length;i++){
          console.log(this.reward_list[i].list)
          this.reward_list[i].list.map((v)=>{
            console.log(v)
            if (v.img && v.type === 'frame' && !this.isWebP(v.img)) {
              console.log('frame')
              //这里动态给ID，列表
              var player = new SVGA.Player('#popular_svga'+v.rank_i);
              var parser = new SVGA.Parser('#popular_svga'+v.rank_i);
              //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
              console.log('svga======')
              console.log(v.img)
              parser.load(v.img, function(videoItem) {
                player.setVideoItem(videoItem);
                player.startAnimation();
              })
            }
          })
        }
      })
    },
    convert() {
      // 标记接口开始请求
      this.loading_request = true
      
      this.overlayShow = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=rank&act=get_rank_reward", {
        params : {
          token: token,
          rank_type: this.ranking_active,
          rank_name: this.day_active,
        }
      }).then(res =>{
        this.overlayShow = false
        this.loading_request = false // 标记接口请求完成
        
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.list = res.data.data.user_list
        this.reward_list = res.data.data.reward_list
        this.SVGA()
        this.finished = true
      }).catch(err => {
        this.overlayShow = false
        // 请求失败也要恢复状态
        this.loading_request = false
        Toast(this.$t('other.network_error') || '网络错误')
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ranking_all_reward.vue